import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataMovingAverage } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import useBundleTranslation from 'i18n';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function MovingAverage(props: IElementDataMovingAverage) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const {
        elementType = '',
        movingAverageValue = '',
        metricMovingAverageInterval = '',
        isReportMetric,
        settings,
    } = props;
    const fieldKey: ElementMetadataFieldName = 'moving_average';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (
        !fieldMetadataDisplay ||
        (!['metric', 'multi-metric chart'].includes(elementType) && !isReportMetric) ||
        !movingAverageValue
    )
        return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel>
                {metricMovingAverageInterval ? metricMovingAverageInterval + ' ' : ''}
                {t(`element_data_label.${fieldKey}`)}
            </ElementDataRowLabel>
            <ElementDataRowValue>{movingAverageValue}</ElementDataRowValue>
        </ElementDataRow>
    );
}
